import { useContext } from 'react'
import { ColumnContext } from './column.context'

export const useColumnUtils = () => {
  const { zone, isCompact, isNight, offsetTime } = useContext(ColumnContext)

  return { isCompact, isNight, zone, offsetTime }
}
